










import { Component, Vue } from "vue-property-decorator";
import { State } from "vuex-class";
import { InlinePriceChange, RateChangesState } from "@/models";

@Component({
  name: "ChangeSetQuickStats"
})

export default class ChangeSetQuickStats extends Vue {
  // ===== Store ===== //
  @State("rateChanges") private rateChanges!: RateChangesState;
  // ===== Props ===== //
  // ===== Data ===== //
  private totalRentChange = 0;
  // ===== Methods ===== //
  private formatStatus(status: string): string {
    if (status === "New Price Change Set") {
      return "Building";
    }
    if (status === "Price Change Set submitted for review") {
      return "Submitted for Review";
    }
    if (
      status === "Price Change Set Queued" ||
      status === "Price Change Set Locked for additional changes" ||
      status === "Price Change Set sent for PMS processing"
    ) {
      return "Processing";
    }
    if (status === "Prices updated") {
      return "Completed";
    }
    if (status === "Reverted prices back to original rates") {
      return "Reverted";
    }
    if (status.includes("Error") || status.includes("Unable to process")) {
      return "Failed";
    }
    return "";
  }
  private calculateTotalRentChange(units: InlinePriceChange[]): number {
    const totalChange = units.reduce((acc: number, unit) => {
      const newRent = unit.newRent ? unit.newRent : 0;
      const difference = newRent - unit.rent;
      return acc + difference;
    }, 0);
    this.totalRentChange = totalChange;
    return totalChange;
  }
  private calculateRentChangeAvgAmountDiff(units: InlinePriceChange[]): number {
    if (units.length) {
      return this.totalRentChange / units.length;
    }
    return 0;
  }
  private calculateRentChangeAvgPercentDiff(units: InlinePriceChange[]): number {
    if (units.length) {
      const totalPercentDiff = units.reduce((acc: number, unit) => {
        const newRent = unit.newRent ? unit.newRent : 0;
        const oldRent = unit.rent;
        const difference = newRent - oldRent;
        const percentDiff = difference / oldRent * 100;
        return acc + percentDiff;
      }, 0);
      return totalPercentDiff / units.length;
    }
    return 0;
  }
  // ===== Computed ===== //
  get selectedUnits(): InlinePriceChange[] {
    if (this.rateChanges.reviewedIPRCSetPriceChanges.length) {
      return this.rateChanges.reviewedIPRCSetPriceChanges;
    }
    return this.rateChanges.selectedUnits;
  }
}
